<template>
  <div v-if="isLogin === 1">
    <el-submenu
      index="3"
      name="userCenter"
      class="topNavBtn userCenterBtn"
      :popper-append-to-body="false"
    >
      <template slot="title">
        <el-link>
          <!--                    {{currentUser.reg_email}}-->
          学者中心
        </el-link>
      </template>
      <el-menu-item>
        <router-link to="/myEvents">我的会议</router-link>
      </el-menu-item>
      <el-menu-item>
        <router-link to="/myInfo">个人信息</router-link>
      </el-menu-item>
      <el-menu-item @click="quitLogin">退出</el-menu-item>
    </el-submenu>
  </div>

  <div class="loginBtnGroup" v-else-if="isLogin === 0">
    <!-- <el-tooltip class="item" effect="dark" content="Login" placement="bottom"> -->
      <el-button @click="openLoginBox" size="small">登录</el-button>
    <!-- </el-tooltip> -->
    <!-- <el-tooltip
      class="item"
      effect="dark"
      content="Register"
      placement="bottom"
    > -->
      <el-button @click="openRegisterBox" size="small">注册</el-button>
    <!-- </el-tooltip> -->
  </div>
</template>

<script>
export default {
  name: 'LoginInfoBox',
  data() {
    return {};
  },
  mounted() {},
  computed: {
    isLogin: {
      get() {
        return this.$store.state.toGetCurrentUser.isLoginKey;
      },
    },
    currentUser: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUser;
      },
    },
  },
  methods: {
    openLoginBox() {
      this.$store.commit('blOpenLoginBox', true);
      // this.$emit("openLoginBox", true)
    },
    openRegisterBox() {
      // this.$emit("openRegisterBox", true)
      this.$store.commit('blOpenRegisterBox', true);
    },
    quitLogin() {
      localStorage.removeItem('eleToken');
      this.$store.commit('AddIsLogin', 0);
      this.$router.push('/');
      this.$emit('minMenuDrawer', false);
    },
  },
};
</script>

<style scoped></style>
